import { render, staticRenderFns } from "./VatDetailEdit.vue?vue&type=template&id=7102f634&scoped=true"
import script from "./VatDetailEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./VatDetailEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/css/scoped/dialog-style.css?vue&type=style&index=0&id=7102f634&prod&scoped=true&lang=css&external"
import style1 from "@/components/settings/styles/vat-detail-edit-style.css?vue&type=style&index=1&id=7102f634&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7102f634",
  null
  
)

/* custom blocks */
import block0 from "@/components/settings/locales/i18n-vat-detail-edit.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fsettings%2Fchildren%2FVatDetailEdit.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports